import { render, staticRenderFns } from "./popUp.vue?vue&type=template&id=0cb4148b&scoped=true&"
import script from "./popUp.vue?vue&type=script&lang=js&"
export * from "./popUp.vue?vue&type=script&lang=js&"
import style0 from "./popUp.vue?vue&type=style&index=0&id=0cb4148b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb4148b",
  null
  
)

export default component.exports